module.exports = __webpack_public_path__ + "static/media/Motorcyclist.fe30f4b8.svg";